import type { ProfileTemplateFieldMode } from '@up2stay/up2promo-api-client';

import { TemplateFieldPolicySelect } from './template-field-policy-select';

interface ModuleEntryPolicyControlProps {
  value: ProfileTemplateFieldMode | undefined;
  onChange: (mode: ProfileTemplateFieldMode) => void;
  labels: { locked: string; free: string };
  className?: string;
}

export function ModuleEntryPolicyControl({
  value,
  onChange,
  labels,
  className,
}: ModuleEntryPolicyControlProps) {
  return (
    <TemplateFieldPolicySelect
      value={value}
      onChange={onChange}
      labels={labels}
      className={className}
    />
  );
}
